module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-blog-3-eba96d1d64420b9f8ea3c7de775f7796.jpg";